<template>
	<el-row>
		<el-table :data="tableDate" style="width: 850px;margin: 0 auto;" row-key="dicId"
			:tree-props="{children: 'sonDicList', hasChildren: 'hasChildren'}">
			<el-table-column label="id" prop="dicId" width="100px"></el-table-column>
			<el-table-column label="剧本类型" prop="dicDesc" width="500px"></el-table-column>
			<el-table-column label="操作" width="200px">
				<template slot-scope="scope">
					<el-button @click="tj(scope.row)" type="text">
						{{scope.row.dicLevel == 1 ?'添加策略':scope.row.dicLevel == 2 ?'修改':''}}
					</el-button>
					<el-button @click="del(scope.row)" type="text" style="color: red;" v-if="scope.row.dicLevel == 2">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- <div style="width: 500px;margin: 20px auto;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div> -->
		<el-dialog :title="title" :visible.sync="centerDialogVisible" @close="gb" width="30%" center>
			<el-form label-position="right" label-width="90px" :model="info" :rules="infoRules" ref="info">
				<el-form-item label="策略类型:" maxlength="20" prop="dicDesc">
					<el-input v-model="info.dicDesc" size="medium" placeholder="请输入(20个字)" style="width: 400px"
						maxlength="20" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item label-width="180px">
					<el-button type="primary" @click="queren">确 定</el-button>
					<el-button @click="centerDialogVisible = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>
<script>
	export default {
		data() {
			return {
				info: {
					dicDesc: '',
					parentId: "",
					dicId: ''
				},
				infoRules: {
					dicDesc: [{
						required: true,
						message: '请输入策略类型',
						trigger: 'change'
					}]
				},
				centerDialogVisible: false,
				title: '',
				tableDate: [],
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 60, 100],
			}
		},
		methods: {
			gb() {
				console.log(1);
			},
			tj(row) {
				this.centerDialogVisible = true
				switch (row.dicLevel) {
					case 1: {
						this.title = '添加策略类型'
						this.info.dicDesc = ''
						this.info.parentId = row.dicId
						break
					}
					case 2: {
						this.title = '编辑策略类型'
						this.info.dicDesc = row.dicDesc
						this.info.dicId = row.dicId
						this.info.parentId = row.parentId
						break
					}
				}
			},
			del(row) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/setting/paiBoCategory/deletePaiBoCategory?dicId=${row.dicId}`, {}).then(
						res => {
							if (res.data.data == 1) {
								this.$message.success(res.data.msg)
							} else {
								this.$message.error(res.data.msg)
							}
							this.getInfo()
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			queren() {
				this.$refs.info.validate(valid => {
					if (valid) {
						if (this.title == '添加策略类型') {
							this.$http.post(`/api/setting/paiBoCategory/addPaiBoCategory`, {
								"dicDesc": this.info.dicDesc,
								"dicModular": 50,
								"dicLevel": 2,
								"parentId": this.info.parentId
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == '编辑策略类型') {
							this.$http.post(`/api/setting/paiBoCategory/updatePaiBoCategory`, {
									"dicDesc": this.info.dicDesc,
									"dicId": this.info.dicId,
									"parentId": this.info.parentId,
									"dicLevel": 2,
								})
								.then(res => {
									if (res.data.data == 1) {
										this.$message.success(res.data.msg)
										this.centerDialogVisible = false
										this.getInfo()
									} else {
										this.$message.error(res.data.msg)
									}
								})
						}
					}
				})
			},
			getInfo() {
				this.$http.post(
					`/api/setting/paiBoCategory/selectPaiBoCategory?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
						"dicModular": 50
					}).then(res => {
					console.log(res);
					this.total = res.data.data.length
					this.tableDate = res.data.data.list
					console.log(this.tableDate);
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>
<style scoped="scoped">

</style>
